import ApplySkeleton from '@core/components/ApplyDialogV2/ApplySkeleton'
import React, { type ReactNode, useEffect, useMemo, useRef, useState } from 'react'
import clsx from 'clsx'
import ApplyNavBtn from '@core/components/ApplyDialogV2/ApplyNavBtn'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import { useTranslation } from 'react-i18next'
import './ApplyDialogV2.scss'

const baseClass = 'ApplyDialogV2'

interface ApplyDialogV2Props {
    className?: string
    children?: ReactNode
}

function ApplyDialogV2({ className = '', children }: ApplyDialogV2Props) {
    const {
        onOpenApply,
        isExpanded,
        isOpen,
        onCloseApply,
        onResizeApply,
        settingsData,
        settingsRefetch,
        settingsError,
        storageData,
        isSettingsFetching,
        isPostFetching,
    } = useApplyV2Context()
    const { t } = useTranslation()
    const nameRef = useRef<HTMLSpanElement>(null)
    const [isEllipsed, setIsEllipsed] = useState(false)

    const isLoading = isSettingsFetching || isPostFetching

    useEffect(() => {
        const el = nameRef.current
        if (el) {
            setIsEllipsed(el.scrollWidth > el.clientWidth)
        }
    }, [isOpen, isExpanded])

    // useEffect(() => {
    //     const handleResize = () => {
    //         const el = nameRef.current
    //         if (el) {
    //             setIsEllipsed(el.scrollWidth > el.clientWidth)
    //         }
    //     }
    //
    //     window.addEventListener('resize', handleResize)
    //     handleResize()
    //
    //     return () => window.removeEventListener('resize', handleResize)
    // }, [])

    useEffect(() => {
        if (isOpen && isExpanded) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = ''
        }

        return () => {
            document.body.style.overflow = ''
        }
    }, [isOpen, isExpanded])

    const navItems = useMemo(() => {
        const navSections = [...Object.values(settingsData?.fields?.section || {})]
            .filter(Boolean)
            .sort((a, b) => a.order - b.order)
        if (settingsData?.fields?.cv) {
            return [
                settingsData.fields.cv,
                { name: 'profile', visible: true, required: true, order: 0 },
                ...navSections,
            ]
        }
        return [{ name: 'profile', order: 0, visible: true, required: true }, ...navSections]
    }, [settingsData])

    if (!isOpen) return null

    return (
        <div
            className={clsx(baseClass, {
                [`${baseClass}__expanded`]: isExpanded,
                [`${baseClass}__opened`]: isOpen,
                [className]: !!className,
            })}
        >
            <div className={`${baseClass}__header`}>
                <ApplySkeleton isLoading={isLoading}>
                    <button onClick={onResizeApply} className={`${baseClass}__header__expand-btn`}>
                        {isExpanded ? (
                            <i className="fa-regular fa-chevron-down"></i>
                        ) : (
                            <i className="fa-regular fa-chevron-up"></i>
                        )}
                    </button>
                </ApplySkeleton>
                <div className={`${baseClass}__header__left`}>
                    <div className={`${baseClass}__header__title`}>
                        {!isEllipsed && (
                            <ApplySkeleton isLoading={isPostFetching}>
                                <span className={`${baseClass}__header__title--application`}>
                                    {t('1589', 'Application')}
                                </span>
                            </ApplySkeleton>
                        )}
                        <ApplySkeleton isLoading={isPostFetching} style={{ maxWidth: '240px' }}>
                            <span className={`${baseClass}__header__title--name`} ref={nameRef}>
                                {storageData?.title}
                            </span>
                        </ApplySkeleton>
                    </div>
                </div>

                {!isExpanded ? (
                    <ApplySkeleton isLoading={isLoading}>
                        <button className={`${baseClass}__header__expand-btn`} onClick={onCloseApply}>
                            <i className="fa-regular fa-xmark-large"></i>
                        </button>
                    </ApplySkeleton>
                ) : (
                    <div className={`${baseClass}__header__nav`}>
                        {/*<ApplyNavBtn>Default</ApplyNavBtn>*/}
                        {/*<ApplyNavBtn>Text</ApplyNavBtn>*/}
                        {/*<ApplyNavBtn state={'optional'}>Optional</ApplyNavBtn>*/}
                        {/*<ApplyNavBtn state={'active'}>Active</ApplyNavBtn>*/}
                        {/*<ApplyNavBtn state={'success'}>Success</ApplyNavBtn>*/}
                        {/*<ApplyNavBtn state={'error'}>Error</ApplyNavBtn>*/}
                        {/*<ApplyNavBtn state={'error'} isLoading={true}>*/}
                        {/*    Error*/}
                        {/*</ApplyNavBtn>*/}
                        {isSettingsFetching
                            ? Array.from({ length: 5 }).map((_, i) => (
                                  <ApplyNavBtn key={i} isLoading={isSettingsFetching} />
                              ))
                            : navItems.map((item, i) => (
                                  <ApplyNavBtn key={item.name} tooltipLabel={item.name} isLoading={isSettingsFetching}>
                                      {item.name}
                                  </ApplyNavBtn>
                              ))}
                    </div>
                )}
            </div>
            <div className={clsx(`${baseClass}__content`, { [`${baseClass}__content--expanded`]: isExpanded })}>
                ddawdawd
            </div>
        </div>
    )
}

export default ApplyDialogV2
